import client from './client';

/**
 * 프리퀀시 - 변수별
 */
export const freqReport = (param) =>
  client.get(`/api/report/freq/graph`, { params: param });
